import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  wrapper: {
    paddingBottom: Theme.px(42),
    paddingTop: Theme.px(78),
  },
});
